import type React from "react";

import { faMicrophone, faPhone, faVideo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { BaseButton } from "shared/atoms/BaseButton";

import { ButtonText, OptionItem, StyledDropDownButton } from "./components/PatientHeaderDropdownStyles";
import { useCallOptions } from "./hooks/useCallOptions";

export const PatientHeaderInfoCallButton: React.FC = () => {
  const { t } = useTranslation();
  const { enabledOptions, disabled, hasSingleOption, hasNoOptions } = useCallOptions();

  if (hasNoOptions) return null;

  if (hasSingleOption) {
    const option = enabledOptions[0];
    return (
      <BaseButton
        data-testid="call-button"
        onClick={option.handler}
        disabled={disabled}
        variant="action"
        icon="video"
        text={t("buttons.call")}
        size="large"
      />
    );
  }

  return (
    <StyledDropDownButton
      id="call-dropdown-button"
      options={enabledOptions.map(option => ({
        children: (
          <OptionItem>
            {option.type === "voice" && <FontAwesomeIcon icon={faMicrophone} />}
            {option.type === "video" && <FontAwesomeIcon icon={faVideo} />}
            {option.type === "phone" && <FontAwesomeIcon icon={faPhone} />}
            <div>{t(`buttons.${option.type}_call`)}</div>
          </OptionItem>
        ),
        onClick: option.handler,
        disabled,
        dataTestId: `${option.type}-call-button`,
      }))}
      disabled={disabled}
      dropdownOrigin="right"
      dataTestId="call-dropdown-button"
    >
      <FontAwesomeIcon icon={faVideo} style={{ height: "16px", width: "16px" }} />
      <ButtonText>{t("buttons.call")}</ButtonText>
    </StyledDropDownButton>
  );
};
